import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Route, Routes } from "react-router-dom";
import Invoices from "./invoices/sections/Invoices";
import InvoicePreview from "./invoices/sections/InvoicePreview";
import InvoiceNoteWizard from "./invoices/pages/InvoiceNoteWizard";
import React from "react";
import { useHasScope } from "../../../config/globalConfig";

const PageInvoices = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'invoices' });
    const hasScope = useHasScope;
    return (
        <Routes>         
            <Route path="/" element={
                <>
                    <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                    <Invoices/>
                </>
            }/>
            <Route path="/:id/*" element={
                <>
                    <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                    <InvoicePreview/>
                </>
            }/>
            <Route path="/note-wizard/:id" element={
                <>
                    <SectionHeader title={t('note-variation-wizard.header.title')} subtitle={t('note-variation-wizard.header.subtitle')}/>
                    <InvoiceNoteWizard/>
                </>
            }/>
        </Routes>
    );
}

export default PageInvoices;